// Toast.js
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = () => {
  return <ToastContainer />;
};

// Helper functions to trigger different types of toasts
const showToast = {
  success: (message) => {
    toast.success(message, {
      position: 'top-right', // Use string literals for position
      autoClose: 3000,
    });
  },
  error: (message) => {
    toast.error(message, {
      position: 'top-right', // Use string literals for position
      autoClose: 3000,
    });
  },
  info: (message) => {
    toast.info(message, {
      position: 'top-right', // Use string literals for position
      autoClose: 3000,
    });
  },
  warning: (message) => {
    toast.warn(message, {
      position: 'top-right', // Use string literals for position
      autoClose: 3000,
    });
  },
};

export { Toast, showToast };
